import { InputHTMLAttributes } from 'react';
import { classNames } from '../utils/helpers';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export default function Input({ label, error, hint, className = '', required, ...rest }: InputProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="text-xs font-medium text-gray-500">
          {label}
          {required && <span className="text-red-600 ml-0.5">*</span>}
        </label>
      )}
      <input
        className={classNames(
          'w-full px-3 py-2 text-sm border rounded-lg outline-none transition-all',
          'border-gray-200 focus:border-violet-600 focus:ring-1 focus:ring-violet-600',
          error ? 'border-red-500' : '',
          className,
        )}
        required={required}
        {...rest}
      />
      {hint  && <span className="text-xs text-gray-400">{hint}</span>}
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
